// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + "monaco-editor" + "." + "63a1e2f0393682335659" + ".css";
};